export default __webpack_public_path__ + "static/media/Chillax-Medium.529ac682.woff";